import UtilsUnit from "../../utils/UtilsUnit";

const WidgetRadioButton = ({ checked, onChange, size = 1 }) => {
  const outerSizePx = UtilsUnit.remToPx(size);
  const innerSizePx = Math.round(outerSizePx * 0.6);

  return (
    <div
      onClick={() => onChange(!checked)}
      style={{
        width: `${outerSizePx}px`,
        height: `${outerSizePx}px`,
        borderRadius: "50%",
        border: "2px solid #BCC6FA",
        backgroundColor: checked ? "#BCC6FA" : "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        cursor: "pointer",
        transition: "all 0.2s ease-in-out",
      }}
    >
      {checked && (
        <div
          style={{
            width: `${innerSizePx}px`,
            height: `${innerSizePx}px`,
            borderRadius: "50%",
            backgroundColor: "#333333E6",
          }}
        />
      )}
    </div>
  );
};

export default WidgetRadioButton;
